// Generated at build time by scripts/inject-version.js - do not edit
export const appVersion = {
  version: '1.0.0',
  commit: '10aa69d1',
};
